import ko from 'knockout';
import 'knockout.validation';
import MicroModal from 'micromodal';
import { httpClient, HTTPClientError } from '../httpClient';
import { SetMessageRequest, Status } from '../interfaces';
import { Log } from '../log';
import { R } from '../Resources.resx';

export class SetMeetingRoomMessageModalViewModel {
	private _validator: KnockoutValidationGroup;

	public errors = ko.observableArray([]);
	public warning = ko.observable('');
	public success = ko.observable(false);
	public isSubmitting = ko.observable(false);
	public message = ko.observable('');
	public maxMessageLength = 200;
	public messageLengthSummary = ko.pureComputed(() => {
		return `${this.message().length}/${this.maxMessageLength}`;
	});
	public showNavigation = ko.pureComputed(() => {
		const isSuccess = this.success();
		return !isSuccess;
	});
	private _videoRoomKey = '';

	constructor() {
		ko.validation.init({
			grouping: { deep: true },
		});

		this._validator = ko.validatedObservable();
		this._validator.errors?.showAllMessages(false);
	}

	public reset = (): void => {
		this.success(false);
		this.errors([]);
		this._validator.errors?.showAllMessages(false);
	};

	public sendMessageToRoom = (): void => {
		if (!this._validator.isValid()) {
			this._validator.errors?.showAllMessages();
			return;
		}

		if (this.isSubmitting()) {
			return;
		}

		this.isSubmitting(true);

		const request: SetMessageRequest = {
			videoRoomKey: this._videoRoomKey,
			message: this.message(),
		};

		httpClient
			.post<Status<string>>('/api/meetings/set-message', request)
			.then((data) => {
				if (data.hasErrors) {
					this.errors(data.errors.map((e) => e.value));
					return;
				}
				this.success(true);
			})
			.catch((error) => {
				if (error instanceof HTTPClientError) {
					// The request was made and the server responded with a status code
					// that falls out of the range of 2xx
					Log.error(
						'Error setting message in the video room. ' +
							error.status +
							': ' +
							(error.data ?? error.message),
					);
				} else {
					// Something happened in setting up the request that triggered an Error
					Log.error('Error setting message in the video room', error.message);
				}
				this.errors([R.ErrorSendMessage]);
			})
			.finally(() => {
				this.isSubmitting(false);
			});
	};

	public showModal = (videoRoomKey: string): void => {
		this._videoRoomKey = videoRoomKey;
		this.reset();

		MicroModal.show('set-message-modal', {
			awaitCloseAnimation: true,
			disableFocus: true,
		});
	};
}
